var _rect, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 31.5,
    height: 19.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 20
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 31.5,
    height: 19.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.8572,
    width: 9.14286,
    height: 20,
    fill: "#FF3131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H9.14286V0H0V20Z",
    fill: "#FF3131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2974 9.32326C18.0542 9.53602 17.6809 9.31309 17.7529 8.99813L18.2858 6.66671L16.762 7.33337L16.0001 5.33337L15.2382 7.33337L13.7144 6.66671L14.2473 8.99813C14.3193 9.31309 13.946 9.53602 13.7028 9.32326L13.172 8.85877C13.0463 8.74881 12.8586 8.74881 12.733 8.85877L12.1906 9.33337L10.6667 8.66671L11.4287 10L10.9534 10.4158C10.8017 10.5487 10.8017 10.7848 10.9534 10.9176L12.9525 12.6667H15.2382L15.6191 14.6667H16.381L16.762 12.6667H19.0477L21.0467 10.9176C21.1985 10.7848 21.1985 10.5487 21.0467 10.4158L20.5715 10L21.3334 8.66671L19.8096 9.33337L19.2672 8.85877C19.1415 8.74881 18.9539 8.74881 18.8282 8.85877L18.2974 9.32326Z",
    fill: "#FF3131"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCa);
export default __webpack_public_path__ + "static/media/CA.f8f18dfeed27c5c550adf44778c76da9.svg";
export { ForwardRef as ReactComponent };